import { createApp } from 'vue';
import App from './App.vue';
/* import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue'; */

import '@ionic/vue/css/core.css';

import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import './theme/variables.scss';
import './theme/styles.css';
import 'swiper/css';
import '@ionic/vue/css/ionic-swiper.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'vue-advanced-cropper/dist/style.css';

import router from '@/router';
import { IonicVue } from '@ionic/vue';
import { i18n } from '@/plugins/i18n';
import pinia from '@/stores';
import VueDatePicker from '@vuepic/vue-datepicker';
/* import { BASE_URL } from '@/utils/constants/api-constants'; */

const app = createApp(App).use(IonicVue).use(router).use(i18n);

app.component('VueDatePicker', VueDatePicker);

app.config.globalProperties.$t = i18n.global.t;
app.use(IonicVue).use(i18n).use(router).use(pinia);

/* if (BASE_URL.SENTRY_ENV === 'production') {
  Sentry.init(
    {
      app,
      dsn: BASE_URL.SENTRY_URL,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
      profilesSampleRate: 1.0,
    },
    SentryVue.init,
  );
} */

router.isReady().then(() => {
  app.mount('#app');
});

// Register global components